export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-chord/src/array.js
// module id = 244
// module chunks = 0